import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DContext } from "../../../context/Datacontext";
import LogsNavigator from "./LogsNavigator";
import Loading from "../Loading";
import { apiFetch } from "../../services/fetchApi";


function SessionHistory() {
    const { BeURL, showAlert } = useContext(DContext);
    const [logs, setLogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalLogs, setTotalLogs] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterToday, setFilterToday] = useState(false);

    const navigate = useNavigate();

    const fetchLogs = () => {
        apiFetch(`${BeURL}/session-history`, {
            method: "post",
            body: JSON.stringify({ currentPage, itemsPerPage }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setLogs(data.logs);
                    setTotalLogs(data.totalLogs || 0);
                } else {
                    showAlert(data.message);
                }
            })
            .catch((err) => {
                console.log("Error in fetching Session history:", err);
                showAlert(
                    "Trouble in connecting to the Server! Try again later or contact support team."
                );
            });
    }
    useEffect(() => {
        let fetchData
        if (BeURL && currentPage && itemsPerPage) {
            fetchLogs()
            fetchData = setInterval(() => { fetchLogs() }, 5000)
        }

        return () => clearInterval(fetchData)
    }, [BeURL, currentPage, itemsPerPage]);

    if (!BeURL) return <Loading />;

    // --- Filtering & Searching ---
    const todayDate = new Date().toISOString().split("T")[0];
    const filteredLogs = logs.filter((log) => {
        const name =
            `${log.userDetails?.fullName || ""
                }`.toLowerCase();

        const matchesSearch =
            log.ipAddress?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            log.userId?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            name.includes(searchTerm.toLowerCase()) ||
            log.userDetails?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            String(log.userDetails?.contact || "").includes(searchTerm);

        const matchesToday = filterToday
            ? log.createdAt?.split("T")[0] === todayDate
            : true;

        return matchesSearch && matchesToday;
    });

    const totalPages = Math.ceil(totalLogs / itemsPerPage);

    return (
        <div className="min-h-[75vh] p-4">
            <LogsNavigator />
            <div className="flex flex-col md:flex-row justify-between items-center mb-4 gap-3">
                <h2 className="text-2xl font-bold text-primary-500">
                    Session History
                </h2>

                {/* Search + Filter */}
                <div className="flex flex-wrap gap-3">
                    <input
                        type="search"
                        placeholder="Search by IP, User ID, Name..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-300"
                    />
                    <button
                        onClick={() => setFilterToday(!filterToday)}
                        className={`px-4 py-2 rounded-lg font-medium ${filterToday
                            ? "bg-primary-500 text-white"
                            : "bg-gray-200 text-gray-700"
                            }`}
                    >
                        {filterToday ? "Today" : "All"}
                    </button>
                </div>
            </div>

            {/* Table */}
            <div className="overflow-auto min-h-[55vh] bg-white rounded-xl shadow-md">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-primary-500 text-white">
                        <tr>
                            <th className="p-3">Timestamp</th>
                            <th className="p-3">Status</th>
                            <th className="p-3">Name</th>
                            <th className="p-3">Email</th>
                            <th className="p-3">Contact</th>
                            <th className="p-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredLogs.length > 0 ? (
                            filteredLogs.map((log) => (
                                <tr
                                    key={log._id}
                                    className="hover:bg-blue-50 transition border-[0.5px] border-slate-100"
                                >
                                    <td className="p-3">
                                        {new Date(log.createdAt).toLocaleString("en-GB")}
                                    </td>
                                    <td
                                        className={`p-3 font-semibold ${log.status === "in"
                                            ? "text-green-600"
                                            : "text-red-600"
                                            }`}
                                    >
                                        {log.status}
                                    </td>
                                    <td className="p-3 font-medium text-primary-500 cursor-pointer" onClick={() => window.open(`/user/${log.userDetails._id}`, "_blank")}>
                                        {log.userDetails
                                            ? (log.userDetails.fullName || "")
                                            : "-"}
                                    </td>
                                    <td className="p-3">{log.userDetails?.email || "-"}</td>
                                    <td className="p-3">{log.userDetails?.contact || "-"}</td>
                                    <td className="p-3">
                                        <button
                                            onClick={() =>
                                                navigate(`/fetch-log-history/${log.userId}`)
                                            }
                                            className="px-3 py-1 rounded-lg bg-gradient-to-r from-primary-100 to-secondary-100 text-white  hover:from-primary-300 hover:to-secondary-300 transition"
                                        // disabled
                                        >
                                            History
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className="p-3 text-center text-gray-500" colSpan="6">
                                    No logs found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination & Controls */}
            <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-3">
                {/* Records per page */}
                <div className="flex items-center gap-2">
                    <label className="text-sm font-medium">Records per page:</label>
                    <select
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        className="px-2 py-1 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-300"
                    >
                        {[10, 20, 25, 50, 100].map((val) => (
                            <option key={val} value={val}>
                                {val}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Pagination buttons */}
                <div className="flex gap-2">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                        className="px-3 py-1 rounded-lg border bg-white hover:bg-primary-50 disabled:opacity-50"
                    >
                        Prev
                    </button>
                    <span className="px-2 py-1">
                        Page {currentPage} of {totalPages || 1}
                    </span>
                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                        className="px-3 py-1 rounded-lg border bg-white hover:bg-primary-50 disabled:opacity-50"
                    >
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SessionHistory;